import {lazy, Suspense} from 'react';
import {Outlet} from 'react-router-dom';
import {Layout as AppLayout} from 'src/layouts/app';
import {paths} from "../paths";

const IndexPage = lazy(() => import('src/pages/crm/index'));
const CRM_Form = lazy(() => import('src/pages/crm/[caseID]/crm-form'));


export const CRMRoute = [
    {
        path: 'crm',
        element: (
            <AppLayout>
                <Suspense>
                    <Outlet/>
                </Suspense>
            </AppLayout>
        ),
        children: [
            {
                index: true,
                element: <IndexPage/>
            },
            {
                path: paths.crm.form,
                element: <CRM_Form/>
            },
        ]
    }
];
